import React, { useState, useEffect } from "react";
import { Card, Row, Col, Accordion, Badge, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { ROLES, ROLE_LABELS } from "../config/permissions";

// Styles supplémentaires
const styles = `
  .aide-container {
    max-width: 1400px;
    margin: 0 auto;
  }

  .aide-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 30px;
    padding: 50px;
    color: white;
    margin-bottom: 40px;
    box-shadow: 0 20px 40px rgba(102, 126, 234, 0.3);
    position: relative;
    overflow: hidden;
  }

  .aide-header::before {
    content: '';
    position: absolute;
    top: -50px;
    right: -50px;
    width: 200px;
    height: 200px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
  }

  .aide-header::after {
    content: '';
    position: absolute;
    bottom: -50px;
    left: -50px;
    width: 300px;
    height: 300px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
  }

  .aide-header-content {
    position: relative;
    z-index: 1;
  }

  .aide-search {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 60px;
    padding: 8px;
    max-width: 600px;
    margin-top: 30px;
  }

  .aide-search input {
    background: transparent;
    border: none;
    color: white;
    padding: 15px 25px;
    width: 100%;
  }

  .aide-search input::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  .aide-search button {
    background: white;
    border: none;
    border-radius: 50px;
    padding: 12px 30px;
    color: #667eea;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .aide-search button:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  }

  .aide-card {
    border: none;
    border-radius: 20px;
    background: white;
    box-shadow: 0 10px 40px rgba(0,0,0,0.08);
    transition: all 0.3s ease;
    overflow: hidden;
    height: 100%;
  }

  .aide-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 50px rgba(102, 126, 234, 0.15);
  }

  .aide-card-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 25px;
    color: white;
    position: relative;
    overflow: hidden;
  }

  .aide-card-header::after {
    content: '';
    position: absolute;
    top: -30px;
    right: -30px;
    width: 100px;
    height: 100px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
  }

  .aide-card-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    margin-bottom: 15px;
  }

  .aide-faq-item {
    border: none;
    border-bottom: 1px solid #f0f0f0;
    background: transparent;
  }

  .aide-faq-item .accordion-button {
    padding: 20px;
    font-weight: 600;
    color: #2d3748;
    background: transparent;
    box-shadow: none;
  }

  .aide-faq-item .accordion-button:not(.collapsed) {
    color: #667eea;
    background: rgba(102, 126, 234, 0.05);
  }

  .aide-faq-item .accordion-button::after {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23667eea'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E");
  }

  .aide-faq-item .accordion-body {
    padding: 0 20px 20px 20px;
    color: #64748b;
    line-height: 1.7;
  }

  .aide-topic-badge {
    background: linear-gradient(135deg, #667eea10 0%, #764ba210 100%);
    color: #667eea;
    padding: 8px 16px;
    border-radius: 30px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .aide-topic-badge:hover {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    transform: translateY(-2px);
  }

  .aide-topic-badge.active {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
  }

  .aide-guide-item {
    padding: 20px;
    border-radius: 15px;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .aide-guide-item:hover {
    background: #f8fafc;
  }

  .aide-guide-icon {
    width: 50px;
    height: 50px;
    border-radius: 15px;
    background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #667eea;
  }

  .aide-contact-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border: none;
    border-radius: 20px;
    padding: 30px;
    text-align: center;
    transition: all 0.3s ease;
  }

  .aide-contact-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(0,0,0,0.1);
  }

  .aide-contact-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    margin: 0 auto 20px;
    box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
  }

  .aide-stats-card {
    background: white;
    border-radius: 15px;
    padding: 20px;
    text-align: center;
    box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  }

  .aide-stats-number {
    font-size: 32px;
    font-weight: 700;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .aide-role-badge {
    display: inline-block;
    padding: 6px 12px;
    border-radius: 30px;
    font-size: 12px;
    font-weight: 600;
    margin-left: 10px;
  }

  .aide-role-badge.admin { background: linear-gradient(135deg, #f43f5e 0%, #e11d48 100%); color: white; }
  .aide-role-badge.gestionnaire { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); color: white; }
  .aide-role-badge.commercial { background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); color: white; }
  .aide-role-badge.magasinier { background: linear-gradient(135deg, #10b981 0%, #059669 100%); color: white; }

  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
    100% { transform: translateY(0px); }
  }

  .float-animation {
    animation: float 3s ease-in-out infinite;
  }
`;

export default function Aide() {
    const [user, setUser] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [activeTopic, setActiveTopic] = useState("Tous");
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        loadUser();
    }, []);

    const loadUser = () => {
        try {
            const userStr = localStorage.getItem("user");
            if (userStr && userStr !== "undefined" && userStr !== "null") {
                const userData = JSON.parse(userStr);
                setUser(userData);
                setUserRole(userData.role || 'commercial');
            }
        } catch (error) {
            console.error("Erreur chargement utilisateur:", error);
        }
    };

    // FAQs de base (accessibles à tous)
    const baseFaqs = [
        {
            question: "Comment scanner un code-barres ?",
            answer: "Utilisez le module Scanner dans Stock > Scanner codes-barres. Vous pouvez utiliser la caméra de votre appareil pour scanner directement, ou saisir le code manuellement. Le produit sera automatiquement recherché dans votre base.",
            category: "scanner",
            roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.COMMERCIAL, ROLES.MAGASINIER]
        },
        {
            question: "Comment créer une facture ?",
            answer: "Allez dans Ventes > Factures > Nouvelle facture. Remplissez les informations du client, sélectionnez les produits, appliquez les éventuelles remises et validez. La facture sera automatiquement numérotée et pourra être envoyée par email au client.",
            category: "factures",
            roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.COMMERCIAL]
        },
        {
            question: "Comment gérer les stocks ?",
            answer: "Le module Stock vous permet de gérer les entrées/sorties, faire des inventaires et suivre les mouvements. Vous pouvez également configurer des alertes pour être notifié quand un produit atteint son seuil critique.",
            category: "stock",
            roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.MAGASINIER]
        }
    ];

    // FAQs additionnelles pour les rôles spécifiques
    const roleSpecificFaqs = {
        [ROLES.ADMIN]: [
            {
                question: "Comment gérer les utilisateurs ?",
                answer: "Allez dans Paramètres > Utilisateurs. Vous pouvez ajouter, modifier ou désactiver des utilisateurs. Chaque utilisateur peut avoir un rôle différent (Admin, Gestionnaire, Commercial, Magasinier) avec des permissions spécifiques.",
                category: "utilisateurs",
                roles: [ROLES.ADMIN]
            },
            {
                question: "Comment configurer les taxes ?",
                answer: "Dans Paramètres > Société > Taxes, vous pouvez configurer les taux de TVA et CSS. Ces taux seront appliqués automatiquement sur vos factures et devis.",
                category: "parametres",
                roles: [ROLES.ADMIN]
            },
            {
                question: "Comment gérer la numérotation des documents ?",
                answer: "Dans Paramètres > Documents > Numérotation, vous pouvez personnaliser les préfixes et le format des numéros de factures, devis, commandes et bons de livraison.",
                category: "parametres",
                roles: [ROLES.ADMIN]
            }
        ],
        [ROLES.GESTIONNAIRE]: [
            {
                question: "Comment analyser les performances ?",
                answer: "La section Statistiques vous permet de suivre votre chiffre d'affaires, les ventes par produit, et d'exporter des rapports détaillés pour analyser vos performances.",
                category: "statistiques",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE]
            },
            {
                question: "Comment gérer les achats ?",
                answer: "Le module Achats vous permet de gérer vos commandes fournisseurs, suivre les réceptions et évaluer vos fournisseurs.",
                category: "achats",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE]
            }
        ],
        [ROLES.COMMERCIAL]: [
            {
                question: "Comment créer un devis ?",
                answer: "Dans Ventes > Devis > Nouveau devis, créez vos propositions commerciales. Vous pouvez les envoyer par email et les convertir en facture une fois acceptés.",
                category: "devis",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.COMMERCIAL]
            },
            {
                question: "Comment gérer les règlements clients ?",
                answer: "Dans Ventes > Règlements, vous pouvez enregistrer les paiements des clients et suivre les échéances.",
                category: "reglements",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.COMMERCIAL]
            }
        ],
        [ROLES.MAGASINIER]: [
            {
                question: "Comment faire un inventaire ?",
                answer: "Dans Stock > Inventaire, créez un nouvel inventaire. Scannez ou saisissez les quantités réelles pour chaque produit. L'application calculera automatiquement les écarts et mettra à jour le stock après validation.",
                category: "stock",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.MAGASINIER]
            },
            {
                question: "Comment suivre la traçabilité ?",
                answer: "Le module Traçabilité vous permet de suivre l'historique complet des mouvements de chaque produit, avec les dates, quantités et utilisateurs.",
                category: "stock",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.MAGASINIER]
            }
        ]
    };

    // Combiner toutes les FAQs accessibles selon le rôle
    const getAllFaqs = () => {
        let allFaqs = [...baseFaqs];
        
        if (userRole && roleSpecificFaqs[userRole]) {
            allFaqs = [...allFaqs, ...roleSpecificFaqs[userRole]];
        }
        
        // Ajouter quelques FAQs communes à tous
        const commonFaqs = [
            {
                question: "Comment exporter des rapports ?",
                answer: "Dans la section Statistiques, vous pouvez exporter les graphiques et données au format PDF ou Excel. Utilisez les filtres pour personnaliser vos rapports et cliquez sur le bouton d'export en haut à droite.",
                category: "statistiques",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.COMMERCIAL]
            },
            {
                question: "Comment réinitialiser mon mot de passe ?",
                answer: "Sur la page de connexion, cliquez sur 'Mot de passe oublié' et suivez les instructions. Un email vous sera envoyé pour réinitialiser votre mot de passe.",
                category: "securite",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.COMMERCIAL, ROLES.MAGASINIER]
            }
        ];
        
        allFaqs = [...allFaqs, ...commonFaqs];
        
        // Supprimer les doublons éventuels
        return allFaqs.filter((faq, index, self) => 
            index === self.findIndex(f => f.question === faq.question)
        );
    };

    // Filtrer les guides selon le rôle
    const getGuidesByRole = () => {
        const allGuides = [
            {
                title: "Démarrage rapide",
                description: "Configurez votre entreprise en 5 minutes",
                icon: "ri-rocket-line",
                color: "#667eea",
                link: "/parametres/societe/infos",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE]
            },
            {
                title: "Gestion des ventes",
                description: "Factures, devis, clients et règlements",
                icon: "ri-shopping-bag-3-line",
                color: "#f59e0b",
                link: "/ventes/factures/liste",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.COMMERCIAL]
            },
            {
                title: "Gestion des achats",
                description: "Fournisseurs, commandes et réceptions",
                icon: "ri-shopping-cart-line",
                color: "#10b981",
                link: "/achats/commandes",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE]
            },
            {
                title: "Gestion du stock",
                description: "Produits, inventaires et mouvements",
                icon: "ri-stack-line",
                color: "#8b5cf6",
                link: "/stock/etat/instantane",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.MAGASINIER]
            },
            {
                title: "Scanner codes-barres",
                description: "Utilisez la caméra pour scanner",
                icon: "ri-qr-code-line",
                color: "#ec4899",
                link: "/stock/scanner",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.COMMERCIAL, ROLES.MAGASINIER]
            },
            {
                title: "Statistiques",
                description: "Analysez vos performances",
                icon: "ri-bar-chart-2-line",
                color: "#ec4899",
                link: "/stats/dashboard",
                roles: [ROLES.ADMIN, ROLES.GESTIONNAIRE, ROLES.COMMERCIAL]
            },
            {
                title: "Paramètres",
                description: "Configuration de l'application",
                icon: "ri-settings-3-line",
                color: "#6b7280",
                link: "/parametres/societe/taxes",
                roles: [ROLES.ADMIN]
            },
            {
                title: "Gestion des utilisateurs",
                description: "Gérez les comptes et permissions",
                icon: "ri-user-settings-line",
                color: "#f43f5e",
                link: "/parametres/utilisateurs",
                roles: [ROLES.ADMIN]
            }
        ];

        return allGuides.filter(guide => 
            guide.roles.includes(userRole) || userRole === ROLES.ADMIN
        );
    };

    const filteredFaqs = getAllFaqs().filter(faq => 
        (activeTopic === "Tous" || faq.category === activeTopic.toLowerCase()) &&
        (searchQuery === "" || faq.question.toLowerCase().includes(searchQuery.toLowerCase()) || faq.answer.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    const topics = [
        "Tous", "Factures", "Stock", "Scanner", "Statistiques", "Achats", "Utilisateurs", "Paramètres", "Sécurité"
    ];

    const getRoleColor = (role) => {
        const colors = {
            [ROLES.ADMIN]: 'danger',
            [ROLES.GESTIONNAIRE]: 'warning',
            [ROLES.COMMERCIAL]: 'info',
            [ROLES.MAGASINIER]: 'success'
        };
        return colors[role] || 'secondary';
    };

    return (
        <>
            <style>{styles}</style>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="aide-container">
                    {/* En-tête avec dégradé et badge du rôle */}
                    <div className="aide-header animate__animated animate__fadeInUp">
                        <div className="aide-header-content">
                            <Row className="align-items-center">
                                <Col lg={8}>
                                    <div className="d-flex align-items-center mb-3">
                                        <h1 className="display-3 fw-bold mb-0">
                                            <i className="ri-question-line me-3"></i>
                                            Centre d'aide
                                        </h1>
                                       
                                    </div>
                                    <p className="lead mb-4 fs-4 opacity-90">
                                        {userRole === ROLES.ADMIN 
                                            ? "Administrateur - Accès complet à toute la documentation"
                                            : userRole === ROLES.GESTIONNAIRE
                                            ? "Gestionnaire - Documentation adaptée à vos responsabilités"
                                            : userRole === ROLES.COMMERCIAL
                                            ? "Commercial - Guides pour vos activités de vente"
                                            : "Magasinier - Documentation pour la gestion du stock"
                                        }
                                    </p>
                                    
                                    {/* Barre de recherche */}
                                    <div className="aide-search d-flex align-items-center">
                                        <input 
                                            type="text" 
                                            placeholder="Rechercher une question, un guide..." 
                                            className="flex-grow-1"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <button className="d-none d-md-block">
                                            <i className="ri-search-line me-2"></i>
                                            Rechercher
                                        </button>
                                    </div>
                                </Col>
                                <Col lg={4} className="text-center d-none d-lg-block">
                                    <div className="float-animation">
                                        <i className="ri-customer-service-2-line" style={{ fontSize: '150px', opacity: 0.2 }}></i>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    {/* Statistiques rapides personnalisées */}
                    <Row className="g-4 mb-5">
                        <Col sm={6} md={3}>
                            <div className="aide-stats-card">
                                <div className="aide-stats-number">24/7</div>
                                <div className="text-muted">Support disponible</div>
                            </div>
                        </Col>
                        <Col sm={6} md={3}>
                            <div className="aide-stats-card">
                                <div className="aide-stats-number">{getAllFaqs().length}+</div>
                                <div className="text-muted">Articles d'aide</div>
                            </div>
                        </Col>
                        <Col sm={6} md={3}>
                            <div className="aide-stats-card">
                                <div className="aide-stats-number">15min</div>
                                <div className="text-muted">Temps de réponse</div>
                            </div>
                        </Col>
                        <Col sm={6} md={3}>
                            <div className="aide-stats-card">
                                <div className="aide-stats-number">98%</div>
                                <div className="text-muted">Satisfaction</div>
                            </div>
                        </Col>
                    </Row>

                    {/* Guides rapides filtrés par rôle */}
                    <h2 className="fw-bold mb-4">
                        <i className="ri-guide-line me-2 text-primary"></i>
                        Guides recommandés pour vous
                    </h2>
                    <Row className="g-4 mb-5">
                        {getGuidesByRole().map((guide, index) => (
                            <Col lg={4} md={6} key={index}>
                                <Link to={guide.link} style={{ textDecoration: 'none' }}>
                                    <Card className="aide-card">
                                        <Card.Body className="p-4">
                                            <div className="d-flex align-items-start gap-3">
                                                <div className="aide-guide-icon">
                                                    <i className={guide.icon}></i>
                                                </div>
                                                <div>
                                                    <h5 className="fw-semibold mb-1" style={{ color: '#1e293b' }}>
                                                        {guide.title}
                                                    </h5>
                                                    <p className="text-muted small mb-0">{guide.description}</p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            </Col>
                        ))}
                    </Row>

                    <Row>
                        {/* Colonne principale - FAQs */}
                        <Col lg={8}>
                            <Card className="aide-card mb-4">
                                <Card.Header className="aide-card-header">
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="aide-card-icon">
                                            <i className="ri-questionnaire-line"></i>
                                        </div>
                                        <div>
                                            <h4 className="fw-bold mb-1">Questions fréquentes</h4>
                                            <p className="mb-0 opacity-75">
                                                {getAllFaqs().length} articles disponibles pour votre rôle
                                            </p>
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body className="p-4">
                                    {/* Filtres par catégorie */}
                                    <div className="d-flex flex-wrap gap-2 mb-4">
                                        {topics.map((topic, index) => (
                                            <span
                                                key={index}
                                                className={`aide-topic-badge ${activeTopic === topic ? 'active' : ''}`}
                                                onClick={() => setActiveTopic(topic)}
                                            >
                                                {topic}
                                            </span>
                                        ))}
                                    </div>

                                    {/* Liste des FAQs */}
                                    {filteredFaqs.length > 0 ? (
                                        <Accordion defaultActiveKey="0" flush>
                                            {filteredFaqs.map((faq, index) => (
                                                <Accordion.Item eventKey={index} key={index} className="aide-faq-item">
                                                    <Accordion.Header>
                                                        {faq.question}
                                                        {faq.roles && faq.roles.length > 0 && (
                                                            <span className="ms-2">
                                                                {faq.roles.map(role => (
                                                                    <Badge 
                                                                        key={role}
                                                                        bg={getRoleColor(role)}
                                                                        className="ms-1"
                                                                        style={{ fontSize: '0.7rem' }}
                                                                    >
                                                                        {ROLE_LABELS[role].substring(0, 3)}
                                                                    </Badge>
                                                                ))}
                                                            </span>
                                                        )}
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <p>{faq.answer}</p>
                                                        <div className="mt-3">
                                                            <Badge bg="light" text="dark" className="px-3 py-2">
                                                                <i className="ri-price-tag-3-line me-1"></i>
                                                                {faq.category}
                                                            </Badge>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            ))}
                                        </Accordion>
                                    ) : (
                                        <div className="text-center py-5">
                                            <i className="ri-questionnaire-line fs-1 text-muted mb-3"></i>
                                            <h5>Aucune question trouvée</h5>
                                            <p className="text-muted">Essayez avec d'autres mots-clés</p>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Colonne latérale */}
                        <Col lg={4}>
                            {/* Contact support */}
                            <Card className="aide-card mb-4">
                                <Card.Body className="p-4">
                                    <div className="aide-contact-card">
                                        <div className="aide-contact-icon">
                                            <i className="ri-customer-service-2-line"></i>
                                        </div>
                                        <h5 className="fw-bold mb-2">Besoin d'aide ?</h5>
                                        <p className="text-muted mb-4">
                                            Notre équipe de support est disponible 24/7 pour vous aider.
                                        </p>
                                        <div className="d-grid gap-3">
                                            <Button 
                                                variant="primary" 
                                                className="w-100 py-3"
                                                style={{
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    border: 'none',
                                                    borderRadius: '15px'
                                                }}
                                            >
                                                <i className="ri-mail-line me-2"></i>
                                                Envoyer un email
                                            </Button>
                                            <Button 
                                                variant="outline-primary" 
                                                className="w-100 py-3"
                                                style={{
                                                    border: '2px solid #667eea',
                                                    color: '#667eea',
                                                    borderRadius: '15px'
                                                }}
                                            >
                                                <i className="ri-phone-line me-2"></i>
                                                Support téléphonique
                                            </Button>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>

                            {/* Documentation par rôle */}
                           
                        </Col>
                    </Row>
                </div>
                <Footer />
            </div>
        </>
    );
}